import { useContext, useEffect, useState } from 'react';
import Loading from 'components/Loading';
import axios from 'axios';
import { report } from 'data/programs';
import { getToken } from 'data/users';
import { ToastContext } from 'context/ToastContext';
import { Button, FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';

const SQ_API = process.env.REACT_APP_SQ_API || "https://seperate-queries-green.afinidata.com/"

const ProgramReports = (props: any) => {
    const { createToast } = useContext(ToastContext);
    const [loading, setLoading] = useState<boolean>(true);
    const [finishedMakingFile, setFinishedMakingFile] = useState<boolean>(false);
    const [programList, setProgramList] = useState<any>([]);
    const [selectedProgram, setSelectedProgram] = useState<any>(null);

    useEffect(()=> {
        const getPrograms = async () => {
            try {
                setProgramList((await report()).data.programs)
            } catch {
                createToast('No se pudo cargar el listado de programas', 'error')
            } finally {
                setLoading(false)
            }
        }
        getPrograms()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    async function getTimeInWhats() {
        if(!selectedProgram) return
        setLoading(true)
        try {
            await axios.get(`${SQ_API}v1/queries/createFile?programId=${selectedProgram.id}`);
            setFinishedMakingFile(true)
        } catch {
            createToast('No se pudo generar el reporte', 'error')
        } finally {
            setLoading(false)
        }
    }

    if( loading ){
        return (
            <Loading />
        )
    }
    if(finishedMakingFile) {
        const downloadFile = async () => {
            try {
                const token = getToken()
                const resp = await fetch(`${SQ_API}v1/queries/getFile?programId=${selectedProgram.id}`, {
                    headers: { Authorization: token ? `Bearer ${token}` : '' }
                })
                if(!resp.ok) throw new Error(`status ${resp.status}`)
                const blob = await resp.blob()
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = `reporte_${selectedProgram.name}.xlsx`
                a.click()
                URL.revokeObjectURL(url)
                setFinishedMakingFile(false)
            } catch {
                createToast('No se pudo descargar el reporte', 'error')
            }
        }
        return(
            <Grid item xs={6} p={1}>
                <Button onClick={downloadFile} fullWidth variant="contained"> descargar reporte</Button>
            </Grid>
        )
    }
    return (
        <>
            <div className="card">
                <div className="card-header">
                    <div className="row">
                        <div className="col-xs-12 col-md-6">
                            <h4 className="card-title">Reporte de programas</h4>
                        </div>
                    </div>
                    <Grid container>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                    <InputLabel id="channel">Program to select</InputLabel>
                                    <Select
                                        labelId="channel"
                                        id="channel"
                                        label="Reporte de programas"
                                        value={selectedProgram?.id ?? ''}
                                        onChange={(v) => setSelectedProgram(programList.find((el:any) => el.id === v.target.value))}
                                    >
                                        {
                                            programList?.map((el:any)=>(
                                                <MenuItem key={el.id} value={el.id}>{el.name}</MenuItem>
                                            ))
                                        }
                                    </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} p={1}>
                            <Button onClick={getTimeInWhats} disabled={!selectedProgram} fullWidth variant="contained"> descargar reporte</Button>
                        </Grid>
                    </Grid>
                    
                </div>
            </div>
        </>
    )
}

export default ProgramReports

